import { render, staticRenderFns } from "./HectareChart.vue?vue&type=template&id=10adefb7&scoped=true"
import script from "./HectareChart.vue?vue&type=script&lang=js"
export * from "./HectareChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10adefb7",
  null
  
)

export default component.exports